// extracted by mini-css-extract-plugin
module.exports = {"position":"Profile_position__2xPqO"};